import "./auth.css";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { authImages } from "../../utils/globalImages";

const CheckEmailModal = (props) => {
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 641);

  // Swipe to close states
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startY = useRef(0);
  const cardRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 641);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Reset drag when modal opens
  useEffect(() => {
    if (props.show) {
      setDragY(0);
      setIsDragging(false);
    }
  }, [props.show]);

  // Swipe handlers
  const handleTouchStart = (e) => {
    if (!isMobile) return;
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isMobile || !isDragging) return;
    const currentY = e.touches[0].clientY;
    const diff = currentY - startY.current;

    // Only allow dragging down
    if (diff > 0) {
      setDragY(diff);
    }
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
    setIsDragging(false);

    // If dragged more than 150px, close the modal
    if (dragY > 150) {
      props.onHide();
    }
    setDragY(0);
  };

  const backdropOpacity = isMobile ? Math.max(0, 1 - dragY / 300) : 1;

  return (
    <>
      <Modal
        centered={!isMobile}
        size="md"
        {...props}
        className={`modern-auth-modal ${isMobile ? "mobile-bottom-sheet" : ""}`}
        dialogClassName="modern-modal-dialog"
        backdrop={true}
        animation={false}
        style={isMobile ? { "--backdrop-opacity": backdropOpacity } : {}}
      >
        <Modal.Body className="modern-modal-body m-0 p-0">
          <div
            ref={cardRef}
            className={`modern-auth-card ${isDarkMode ? "dark-mode dark" : "light-mode light"}`}
            style={
              isMobile
                ? {
                    transform: `translateY(${dragY}px)`,
                    transition: isDragging ? "none" : "transform 0.3s ease-out",
                  }
                : {}
            }
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            {/* Swipe Handle - Only on mobile */}
            {isMobile && (
              <div className="swipe-handle-container">
                <div className="swipe-handle" />
              </div>
            )}

            <div className="d-center">
              <img
                width={135}
                height={93}
                alt="email-image"
                className="mb-32px"
                src={authImages.emailIcon}
              />
            </div>

            <h2
              className={`text-center text-24px text-fw-400 mb-0 ${
                isDarkMode ? "text-white" : "text-deep-purple"
              }`}
            >
              Check Your Email
            </h2>
            <p
              className={`d-center w-100 text-16px text-fw-400 text-new-order email_text mt-3 mb-3 mx-0 ${
                isDarkMode ? "text-light-gray" : "text-charcoal-gray"
              }`}
            >
              We emailed you with the instructions to reset your password
            </p>

            <div className="d-flex gap-3 justify-content-center mt-4">
              <button
                type="button"
                onClick={() => props.onHide()}
                className={`w-100 ${
                  isDarkMode
                    ? "filled-medium-deep-yellow-btn-dark"
                    : "filled-medium-deep-purple-btn-light"
                }`}
              >
                OK
              </button>
            </div>
            {isMobile && (
              <div className="swipe-handle-container-bottom">
                <div className="swipe-handle-bottom" />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CheckEmailModal;
